import React, { Component } from "react";
import Poule from "../../components/structure/Poule";
import { getResultSpotName } from "../../util/GetResultSpotName";
import { languages } from "../../constants/languages";

class PouleContainer extends Component {
  state = {
    teams: {},
    teamsLoaded: false,
    resultSpots: {},
    resultSpotsLoaded: false,
    matches: [],
  };

  UNSAFE_componentWillMount = () => {
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let pouleKeyName = this.props.poule.fase;
    if (this.props.poule.bracket) {
      let bracket = this.props.bracketsByKey[this.props.poule.bracket] || {};
      pouleKeyName =
        this.props.poule.bracketRound === bracket.size && !bracket.subBracketTo
          ? this.props.poule.fase
          : this.props.poule.fase +
            "-" +
            this.props.poule.bracketRound +
            "-" +
            this.props.poule.bracket;
    }

    this.unsubscribe = tournamentRef
      .collection("teams")
      .where("division", "==", this.props.division.id)
      .where("poule" + pouleKeyName, "==", this.props.poule.id)
      .onSnapshot((querySnapshot) => {
        let teams = {};
        querySnapshot.forEach((doc) => {
          let team = doc.data();
          team["id"] = doc.id;
          teams[team["numInPoule" + pouleKeyName]] = team;
        });
        this.setState({
          teams: teams,
          teamsLoaded: true,
        });
      });

    this.unsubscribe2 = tournamentRef
      .collection("resultSpots")
      .where("division", "==", this.props.division.id)
      .where("poule" + this.props.poule.fase, "==", this.props.poule.id)
      .onSnapshot((querySnapshot) => {
        var resultSpots = {};
        querySnapshot.forEach((doc) => {
          let resultSpot = doc.data();
          resultSpot["id"] = doc.id;
          resultSpot["resultSpot"] = true;
          // resultSpot["name"] = getResultSpotName(
          //   resultSpot,
          //   this.props.resultSpotsAll,
          //   this.props.poulesByKey,
          //   this.props.divisionsObject
          // );
          resultSpots[resultSpot["numInPoule" + this.props.poule.fase]] =
            resultSpot;
        });
        this.setState({
          resultSpots: resultSpots,
          resultSpotsLoaded: true,
        });
      });

    this.unsubscribeMatches = tournamentRef
      .collection("matches")
      .where("poule", "==", this.props.poule.id)
      .onSnapshot((querySnapshot) => {
        var matches = [];
        querySnapshot.forEach(function (doc) {
          let match = doc.data();
          match["id"] = doc.id;
          matches.push(match);
        });
        matches.sort((a, b) => {
          return a.numInPoule > b.numInPoule;
        });
        this.setState({
          matches: matches,
        });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribe();
    if (this.unsubscribe2) {
      this.unsubscribe2();
    }
    this.unsubscribeMatches();
  };

  render() {
    var teams = [];
    for (let i = 0; i < this.props.poule.pouleSize; i++) {
      let teamData = {};
      if (this.state.teams[i]) {
        teamData = this.state.teams[i];
      } else if (this.state.resultSpots[i] && !this.props.poule["status" + i]) {
        teamData = this.state.resultSpots[i];
        teamData["name"] = getResultSpotName(
          this.state.resultSpots[i],
          this.props.resultSpotsAll,
          this.props.poulesByKey,
          this.props.divisionsObject
        );
      } else if (this.props.poule["status" + i]) {
        let name = "";
        if (this.props.poule["status" + i] === "bye") {
          name = languages.structure.bye;
        } else if (this.props.poule["status" + i] === "noShow") {
          name = languages.structure.noShow;
        }
        teamData = {
          id: i.toString(),
          name: name,
          status: this.props.poule["status" + i],
          empty: true,
        };
        teamData["poule" + this.props.poule.fase] = this.props.poule.id;
        teamData["numInPoule" + this.props.poule.fase] = i;
      } else {
        teamData = {
          id: i.toString(),
          name: languages.structure.emptySpot,
          empty: true,
        };
        teamData["poule" + this.props.poule.fase] = this.props.poule.id;
        teamData["numInPoule" + this.props.poule.fase] = i;
      }
      if (this.props.bracket) {
        teamData["isInBracket"] = true;
      }
      teams.push(teamData);
    }

    return (
      <div>
        <Poule
          tournament={this.props.tournament}
          division={this.props.division}
          poule={this.props.poule}
          teams={teams}
          matches={this.state.matches}
          handleClickPouleSpot={this.props.handleClickPouleSpot}
          resultSpotsNotDivided={this.props.resultSpotsNotDivided}
          fase={this.props.fase}
          belongsToBracket={this.props.belongsToBracket}
          onRef={this.props.onRef}
          toggleLosersFinal={this.props.toggleLosersFinal}
          showLosersFinal={this.props.showLosersFinal}
          toggleResultSpotType={this.props.toggleResultSpotType}
          bracket={this.props.bracket}
          teamsLoaded={this.state.teamsLoaded}
          resultSpotsLoaded={this.state.resultSpotsLoaded}
          userStatus={this.props.userStatus}
          tournamentStatus={this.props.tournamentStatus}
          toggleFinishedDialog={this.props.toggleFinishedDialog}
          user={this.props.user}
          resultsPage={this.props.resultsPage}
          poulesByKey={this.props.poulesByKey}
          daysByKey={this.props.daysByKey}
          toggleUpgradeDialog={this.props.toggleUpgradeDialog}
          bracketsByKey={this.props.bracketsByKey}
        />
      </div>
    );
  }
}

export default PouleContainer;
